import React, { FC, useState, useCallback, useEffect, useRef } from 'react';
import { Button, List, ListItem, ListItemText, Dialog, withStyles, DialogTitle, TextFieldProps, Tooltip, Typography, DialogContent, DialogContentText, DialogActions, TextField, Select, MenuItem, IconButton } from '@material-ui/core';
import { ITemplate, IUpload, IError } from "../types/types";
import { get, post, postv2, upload, download } from "../fetchers/fetchers";
import { CloudUpload } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import DownloadIcon from '@material-ui/icons/GetApp';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import fileDownload from 'js-file-download';

import { API_URL } from "../env";





interface TemplateDialogProps {
    open: boolean;
    onClose: () => void;
    onDownload: (selectedTemplate: ITemplate | null, uploadedTemplate: File | null, sate_id: number | null) => void;
    state_id: number;

}
const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const TemplateDialog: FC<TemplateDialogProps> = ({ open, onClose, onDownload, state_id }) => {
    const [editTemplate, setEditTemplate] = useState<ITemplate | null>(null);
    const [selectedTemplate, setSelectedTemplate] = useState<ITemplate | null>(null);
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);
    const [templates, setTemplates] = useState<ITemplate[]>([])
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [fileID, setFileID] = useState<IUpload>();
    const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
    const [errorLogs, setErrorLogs] = useState<IError[]>([]);
    const [reload, setReload] = useState<boolean>(true);
    const [uploadConfirmed, setUploadConfirmed] = useState<boolean>(false);
    const [uploadedTemplate, setUploadedTemplate] = useState<ITemplate | undefined>(undefined);
    const [currentStateID, setCurrentStateID] = useState<number>(state_id);

    const [currentTemplateName, setCurrentTemplateName] = useState<string>('');
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const getTemplates = async () => {
        const ts = await get<ITemplate[]>(API_URL + "reports/");
        setTemplates(ts)
    }

    const downloadFile = async (file_uuid: number) => {
        return await download(API_URL + "upload/" + file_uuid);
    }

    const handleDownloadTemplate = async (template: ITemplate) => {
        if (template.file_uuid) {
            downloadFile(template.file_uuid).then(({ data, filename }) => {
                fileDownload(data, filename);
            })
        }

    };
    const updateTemplate = async (template: ITemplate) => {
        return await post<ITemplate>(API_URL + "reports/", template)
    }

    const handleDeleteTemplate = async (template: ITemplate) => {
        // copy editTemplate
        let t = { ...template };
        delete t.id;
        delete t.created_at;
        delete t.sub_templates;

        t.is_active = false;
        updateTemplate(t).then(() => {
            setReload(true)
        })
    }

    const handleEditTemplate = async (template: ITemplate) => {
        // Call your API endpoint for editing a template.
        // The implementation will depend on the details of your API.
        // let filename = "name";
        // setSelectedFile(filename);

        setEditTemplate(template);
        setCurrentTemplateName(template.name);
        setOpenFileUpload(true)

    };

    useEffect(() => {
        if (open || reload) {
            getTemplates();
            setReload(false)

        }
        setCurrentStateID(state_id)

    }, [open, reload, state_id]);

    const handleClose = () => {
        setOpenCreateDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const uploadFile = async (file: any) => {
        const d = await upload<IUpload>(API_URL + "upload/", file);
        setFileID(d)
    }

    const handleCapture = ({ target }: any) => {
        let formData = new FormData();
        formData.append("file", target.files[0]);
        uploadFile(formData).then(() => setSelectedFile(target.files[0].name))
    };

    const handleTemplateSelection = useCallback((event: React.ChangeEvent<{ value: unknown }>) => {
        setSelectedTemplate(templates.find(template => template.id === event.target.value) || null);
    }, [templates]);

    const handleTemplateUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setUploadedFile(event.target.files ? event.target.files[0] : null);
    }, []);

    const handleDownload = useCallback(() => {
        onDownload(selectedTemplate, null, currentStateID);
    }, [selectedTemplate, onDownload, currentStateID]);

    const handleOpenFileUpload = () => {
        setOpenFileUpload(true)
    }
    const handleCloseFileUpload = () => {
        setErrorLogs([])
        setCurrentTemplateName("")
        setSelectedFile(null)
        setEditTemplate(null)
        setOpenFileUpload(false)
    }
    const addTemplate = async () => {

        if (fileID) {
            return await post<ITemplate>(API_URL + "reports/", {
                file_uuid: fileID.uuid,
                is_sub_template: false,
                version: 2,
                name: currentTemplateName
            })
        }
    }

    const uploadTemplate = () => {
        if (fileID) {

            if (editTemplate) {
                let t = { ...editTemplate };
                delete t.id;
                delete t.created_at;
                delete t.sub_templates;
                t.name = currentTemplateName;
                t.file_uuid = fileID?.uuid;

                updateTemplate(t).then(() => {
                    setUploadConfirmed(true)
                    setSelectedFile(null)
                    setUploadConfirmed(false)
                    setReload(true)
                    setOpenFileUpload(false)
                    setEditTemplate(null)
                })

            }
            else {
                addTemplate().then(() => {
                    setUploadConfirmed(true)
                    setSelectedFile(null)
                    setUploadConfirmed(false)
                    setReload(true)
                    setOpenFileUpload(false)
                })
            }
        }
    }

    const create_upload_dialog = () => {
        return (
            <Dialog open={openFileUpload} onClose={handleCloseFileUpload} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Upload Template</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Upload or edit Template.
                        </Typography>

                        <p />

                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Template name"
                            type="text"
                            fullWidth
                            value={currentTemplateName}
                            onChange={(event) => setCurrentTemplateName(event.target.value)}
                        />

                        {!selectedFile && <div>
                            <input
                                accept=".docx"
                                id="icon-button-upload"
                                type="file"
                                hidden
                                onChange={handleCapture}
                            />

                            <label htmlFor="icon-button-upload">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUpload />}
                                >
                                    Upload
                                </Button>
                            </label>

                        </div>}
                        {selectedFile && <div>
                            {selectedFile}
                        </div>}
                        <p />

                        <List dense={true}>

                            {errorLogs.map((e) => {
                                return (
                                    <ListItem>
                                        <ListItemText
                                            primary={e.error}
                                        />
                                    </ListItem>)
                            })}
                        </List>


                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <Button onClick={handleCloseFileUpload} color="primary">
                        Cancel
                    </Button>
                    {selectedFile && <Button onClick={uploadTemplate} color="primary">
                        Submit
                    </Button>}

                </DialogActions>
            </Dialog>
        )
    }
    return (<>
        {create_upload_dialog()}
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Select or Upload Template for Report</DialogTitle>
            <DialogContent>
                <DialogContentText>Please select a template or upload a new one:</DialogContentText>
                <Select value={selectedTemplate?.id || ''} onChange={handleTemplateSelection}>
                    {templates.map(template => (
                        <MenuItem value={template.id}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography style={{ flexGrow: 1 }}>{template.name}</Typography>
                                <IconButton onClick={() => handleDownloadTemplate(template)}>
                                    <DownloadIcon />
                                </IconButton>
                                <IconButton onClick={() => handleEditTemplate(template)}>
                                    <EditIcon />
                                </IconButton>
                                <IconButton onClick={() => handleDeleteTemplate(template)}  >
                                    <DeleteIcon />
                                </IconButton>

                            </div>
                        </MenuItem>
                    ))}
                </Select>
                <Tooltip title="Upload new template" placement={'bottom-end'}>
                    <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleOpenFileUpload()} >
                        <AddIcon />
                    </AddingButton>
                </Tooltip>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleDownload} disabled={!selectedTemplate && !uploadedTemplate}>Download</Button>
            </DialogActions>
        </Dialog>
    </>
    );

};

export default TemplateDialog;
